import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { AppStampDutyCalculatorModule } from "./app-stamp-duty-calculator/app-stamp-duty-calculator.module";

if (environment.production) {
    

}


enableProdMode();

var location = window.location.href;

if (location.indexOf("start") > 0) {
    platformBrowserDynamic().bootstrapModule(AppModule)
        .catch(err => console.error(err));
}
else if (location.indexOf("calculator") > 0) {
    platformBrowserDynamic().bootstrapModule(AppStampDutyCalculatorModule)
        .catch(err => console.error(err));
}
